import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import LitImage from './images/LitImage';
import PostcodeSearch from './PostcodeSearch';
import TrustPilot from './TrustPilot';
import useScreenSize from '../hooks/useScreenSize';
import LitStructuredText from './generic/LitStructuredText';
const HomeHero = ({ data }) => {
  const [videoHasFinished, setVideoHasFinished] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const [inputDisplayValue, setInputDisplayValue] = useState('');
  const screenSize = useScreenSize();

  const {
    heading,
    smallHeading,
    subheading,
    smallBottomText,
    additionalText,
    heroImageMobile,
    heroImageDesktop,
    mode,
    layout,
    nobottomPadding,
    isPostcodeSearch,
    rowReverse,
    centreAlign,
    heroVideoDesktop,
    heroVideoMobile,
    heroVideoStillDesktop,
    heroVideoStillMobile,
    floatingImageLeft,
    floatingImageRight,
  } = data;

  return (
    <div className={` ${mode}`}>
      {heroVideoDesktop ? (
        !videoHasFinished ? (
          <video
            autoPlay
            muted
            onEnded={() => {
              setVideoHasFinished(true);
            }}
            style={{ width: '100%' }}
          >
            <source
              src={
                screenSize.width >= 750
                  ? heroVideoDesktop.url
                  : heroVideoMobile.url
              }
              type="video/mp4"
            />
          </video>
        ) : (
          <LitImage
            image={
              screenSize.width >= 750
                ? heroVideoStillDesktop
                : heroVideoStillMobile
            }
            alt=""
          />
        )
      ) : (
        <div
          className={`${
            layout === 'Grid' && !rowReverse
              ? 'home-hero-grid'
              : layout === 'Grid' && rowReverse
                ? 'home-hero-grid-reverse'
                : 'home-hero'
          } ${heroVideoDesktop && 'video-promotion-hero'}`}
        >
          {layout !== 'Grid' && !floatingImageLeft && (
            <div
              style={{ minWidth: '300px', minHeight: '300px' }}
              className="hero-image-full-width"
            >
              <LitImage
                image={
                  screenSize.width >= 850 ? heroImageDesktop : heroImageMobile
                }
                alt="Promotion banner"
              />
            </div>
          )}
          {floatingImageLeft && (
            <div className="hero-floating-image-left">
              <LitImage image={floatingImageLeft} />
            </div>
          )}
          {floatingImageRight && (
            <div className="hero-floating-image-right">
              <LitImage image={floatingImageRight} />
            </div>
          )}
          {/* PurgeCSS include: home-hero-content-right-align, home-hero-content-left-align, home-hero-content-centre-align */}
          <div
            className={`home-hero-content-${
              rowReverse
                ? 'left-align'
                : centreAlign
                  ? 'centre-align'
                  : !rowReverse
                    ? 'right-align'
                    : 'left-align'
            }`}
          >
            <div className="home-hero-primary-headings">
              <div className={`${mode}`}>
                {smallHeading && <LitStructuredText data={smallHeading} />}
                {heading && (
                  <div className="home-hero-main-heading">
                    <LitStructuredText data={heading} />
                  </div>
                )}
                {subheading && <LitStructuredText data={subheading} />}
                {additionalText && (
                  <div className="home-hero-additional-text">
                    <LitStructuredText data={additionalText} />
                  </div>
                )}
              </div>
            </div>
            <div className="home-hero-postcode-bottom-text">
              {isPostcodeSearch && (
                <div className="PostcodeSearchPrimary">
                  <PostcodeSearch
                    placeholder="Enter postcode"
                    selectedAddress={selectedAddress}
                    setSelectedAddress={setSelectedAddress}
                    inputDisplayValue={inputDisplayValue}
                    setInputDisplayValue={setInputDisplayValue}
                    textButton={'GO'}
                  />
                </div>
              )}
              <div className="home-hero-bottom-text">
                <LitStructuredText data={smallBottomText} />
              </div>
            </div>
          </div>
          {layout === 'Grid' && (
            <div className="home-hero-image-grid">
              <LitImage
                image={
                  screenSize.width >= 800 ? heroImageDesktop : heroImageMobile
                }
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HomeHero;
export const fragment = graphql`
  fragment ModularHomeHero on DatoCmsHomeHeroBlock {
    internal {
      type
    }
    heading {
      value
    }
    smallHeading {
      value
    }
    subheading {
      value
    }
    additionalText {
      value
      links {
        __typename
        ... on DatoCmsMediaText {
          id: originalId
          mediaImage {
            gatsbyImageData
          }
          header {
            value
          }
          content {
            value
          }
        }
      }
    }
    smallBottomText {
      value
      links {
        __typename
        ... on DatoCmsMediaText {
          id: originalId
          mediaImage {
            gatsbyImageData
          }
          header {
            value
          }
          content {
            value
          }
        }
      }
    }
    heroImageMobile {
      gatsbyImageData
    }
    heroImageDesktop {
      gatsbyImageData
    }
    floatingImageLeft {
      gatsbyImageData
    }
    floatingImageRight {
      gatsbyImageData
    }
    mode
    layout
    nobottompadding
    isPostcodeSearch
    rowReverse
    centreAlign
    videoStillDesktop {
      gatsbyImageData
    }
    videoStillMobile {
      gatsbyImageData
    }
    heroVideoMobile {
      url
    }
    heroVideoDesktop {
      url
    }
  }
`;
